
document.addEventListener('DOMContentLoaded' , () =>{
	// select 기본 place 색상값
	const $placeholder = $("select[placeholder]");
		if ($placeholder.length) {
		$placeholder.each(function() {
			const $this = $(this);

			// Initial
			$this.addClass("placeholder-shown");
			const placeholder = $this.attr("placeholder");
			$this.prepend(`<option value="" selected>${placeholder}</option>`);

			// Change
			$this.on("change", (event) => {
			const $this = $(event.currentTarget);
			if ($this.val()) {
				$this.removeClass("placeholder-shown").addClass("placeholder-hidden");
			} else {
				$this.addClass("placeholder-shown").removeClass("placeholder-hidden");
			}
			});
		});
	}

	//header
	if(document.querySelector('.header')){
		const header = document.querySelector(".header"),
			headerHeight = header.offsetHeight - 100;
		
		window.onscroll = function () {
		  let windowTop = window.scrollY;			

		  if (windowTop >= headerHeight) {
			header.classList.add("scroll");
		  } else {
			header.classList.remove("scroll");
		  }
		};
		let headerH = document.getElementById('header').offsetHeight,
			contentsH = document.querySelector('.contents');

		if(document.querySelector('.lnb')){
			let lnbH = document.querySelector('.lnb').offsetHeight;

			contentsH.style.marginTop = headerH + lnbH + 'px';
		}else{
			contentsH.style.marginTop = headerH + 'px';
		}
		
		//search
		const btnSearch = document.querySelector('.search-btn'),
			  headerSearch = document.querySelector('.header-top .search-area');

		btnSearch.addEventListener('click' , ()=>{
			headerSearch.classList.toggle('on');
		})

		//mb gnb
		const mbGnb = document.querySelector('.mb-gnb'),
			  depthOne = mbGnb.querySelectorAll('.depth-01'),
			  depthTwo = mbGnb.querySelectorAll('.depth-02'),
			  closeBtn = mbGnb.querySelector('.mb-gnb--top__close'),
			  mbGnbOpen = document.querySelector('.gnb-btn');

		mbGnbOpen.addEventListener('click' , ()=>{
			mbGnb.style.display = 'block';
		})
		closeBtn.addEventListener('click' , ()=>{
			mbGnb.style.display = 'none';
		})

		depthOne.forEach((el , idx) => {
			el.addEventListener('click' , ()=>{
				el.classList.toggle('on');
				depthTwo.forEach((el, idx) =>{
					el.classList.remove('on');
				})
			})
		})

		//side slide
		$('.side__slide').slick({
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
			prevArrow : $('.side__content .control__prev'),
			nextArrow : $('.side__content .control__next')
		});
	}

	// footer
	if(document.querySelector('.footer')){
		const topMove = document.querySelector('.quick-menu__btn-top');
		topMove.addEventListener('click' , ()=>{
			window.scrollTo({top : 0, behavior: "smooth"});
		})
	}

	// lnb
	if(document.querySelector('.lnb-wrap')){
		if(window.innerWidth <= 768){
			const lnbTit = document.querySelector('.lnb-wrap'),
				tit = lnbTit.querySelector('.lnb-tit--wrap__text button'),
				hiddenBox = lnbTit.querySelector('.lnb-tit--list'),
				toggleBtn = document.querySelector('.js_toggle_btn');

			tit.addEventListener('click' , ()=>{
				tit.classList.toggle('on');
				hiddenBox.classList.toggle('on');

				if(toggleBtn.classList.contains('active')){
					toggleBtn.classList.remove('active');
				}
			})
		}
	}

	//datepicker
	if(document.querySelector('.datepicker')){
		$(".datepicker input").datepicker({
			dateFormat: 'yy-mm-dd',
			showOtherMonths: true,
			prevText: '이전 달',
			nextText: '다음 달',
			monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			dayNames: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
			showMonthAfterYear: true,
			yearSuffix: '',
			firstDay:1
		});
	}
	
	//file
	if(document.querySelector('.file-li')){
		const fileList = document.querySelectorAll('.file-list');
		let filePlus = document.querySelector('.file-plus');
		let i = 0;

		filePlus.addEventListener('click' , () => {
			let fileArea = document.querySelector('.form__content__file'),
				fileList = fileArea.querySelector('.file-list'),
				fileClone = fileList.cloneNode(true);
				
				fileArea.appendChild(fileClone);

		})
			
		fileList.forEach((el , idx) => {
			let fileVal = el.querySelector('.upload-text'),
				file = el.querySelector('.input-file');

			file.addEventListener('change' , () => {
				fileVal.value = file.value;
			})
		});
	}

	if(document.querySelector('.js-n-slide')){
		//n-slide
		$(".js-n-slide").each(function(index, item){
			$(item).slick({
				infinite: true,
				arrows: true,
				dots: false,
				autoplay: true,
				autoplaySpeed: 5000,
				slidesToScroll:1,
				slidesToShow:1,
				prevArrow : $(item).closest('.js-n-slide-area').find('.control__prev'),
				nextArrow : $(item).closest('.js-n-slide-area').find('.control__next')
			});
		});
	}

	if(document.querySelector('.bottom-banner')){
		//bottom-banner
		$(".bottom-banner__list").each(function(index, item){
			let bannerList = $(item).find('.list');

			$(bannerList).slick({
				infinite: true,
				arrows: true,
				dots: false,
				autoplay: false,
				autoplaySpeed: 5000,
				variableWidth: true,
				slidesToScroll:1,
				slidesToShow:3,
				prevArrow : $(item).find('.prev'),
				nextArrow : $(item).find('.next')
			});
		});
	}	

	// 비밀번호 보기
	// const pwChange = document.querySelectorAll('.login--con__pw');

	// class pwBox {
	// 	constructor(target) {
	// 		this.target = target;
	// 		this.pwBtn = this.target.querySelector('.pw-change-btn');
	// 		this.pwInput = this.target.querySelector(".pw-input");
	// 	}

	// 	pwChangeFn() {
	// 		const _this = this;
			
	// 		this.pwBtn.addEventListener("click" , function(){
	// 			if(_this.pwInput.type === 'password'){
	// 				_this.pwInput.type = 'text';
	// 				_this.pwBtn.classList.add('on');
	// 			}else{
	// 				_this.pwInput.type = 'password';
	// 				_this.pwBtn.classList.remove('on');
	// 			}
	// 		})
	// 	}
	// }    
	// pwChange.forEach(el => {        
	// 	new pwBox(el).pwChangeFn();
	// });
});
